import { Button } from '@/components/ui/button'
import type { FormNavigationLayout, FormQuestionAlignment } from '@/lib/form-theme'
import { cn } from '@/lib/utils'
import { Loader2 } from 'lucide-react'

export function NavigationButtons({
  canGoBack,
  isSubmitting,
  layout = 'inline',
  questionAlign = 'left',
  showBackButton = true,
  onNext,
  onBack,
}: {
  canGoBack: boolean
  isSubmitting: boolean
  layout?: FormNavigationLayout
  questionAlign?: FormQuestionAlignment
  showBackButton?: boolean
  onNext: () => void
  onBack: () => void
}) {
  const visibleBack = showBackButton && canGoBack
  const justify =
    layout === 'split'
      ? 'justify-between'
      : questionAlign === 'center'
        ? 'justify-center'
        : questionAlign === 'right'
          ? 'justify-end'
          : 'justify-start'

  return (
    <div
      className={cn(
        'mt-8 flex gap-3',
        layout === 'stacked' ? 'flex-col items-stretch' : `flex-wrap items-center ${justify}`,
      )}
    >
      <div className={cn('flex flex-wrap items-center gap-3', layout === 'split' && 'order-2')}>
        <Button
          onClick={onNext}
          disabled={isSubmitting}
          className={layout === 'stacked' ? 'w-full' : undefined}
          style={{
            background: 'var(--form-button-a11y,var(--form-button,#6366F1))',
            borderRadius: 'var(--form-radius,8px)',
            color: 'var(--form-button-text,#fff)',
            fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
          }}
        >
          {isSubmitting && <Loader2 className="size-4 animate-spin" />}
          下一步 →
        </Button>
        <span
          className="hidden md:inline"
          style={{
            color: 'var(--form-answer,#64748B)',
            fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
            fontSize: 'var(--form-meta-size,0.9375rem)',
          }}
        >
          按 Enter ↵
        </span>
      </div>
      {showBackButton && (
        <Button
          variant="outline"
          onClick={onBack}
          disabled={!visibleBack}
          className={cn(layout === 'stacked' && 'w-full', layout === 'split' && 'order-1')}
          style={{
            background: 'color-mix(in srgb, var(--form-bg,#F8FAFC) 82%, white)',
            borderColor: 'color-mix(in srgb, var(--form-accent,#6366F1) 32%, transparent)',
            borderRadius: 'var(--form-radius,8px)',
            color: 'var(--form-text,#0F172A)',
            fontFamily: 'var(--form-body-font,var(--form-font,Geist))',
          }}
        >
          ← 返回
        </Button>
      )}
    </div>
  )
}
